import type { ComponentProps } from 'react';
import { Column as AriaColumn, ColumnResizer, composeRenderProps } from 'react-aria-components';
import cx from 'clsx';

import { useTableVariant } from './Table';

import styles from './Column.module.css';

type Props = { isResizable?: boolean; isNumbered?: boolean } & ComponentProps<typeof AriaColumn>;

export const Column = ({ children, isResizable, isNumbered, ...props }: Props) => {
  const variant = useTableVariant();

  return (
    <AriaColumn
      {...props}
      className={composeRenderProps(props.className, (className) =>
        cx(className, styles.Column, { [styles.slim]: variant === 'slim' }),
      )}
    >
      <div className={cx(styles.ColumnInner, { [styles.IsNumbered]: isNumbered })}>
        {children as React.ReactNode}
        {
          // this is not prod ready so use it with caution
          isResizable && <ColumnResizer className={styles.ColumnResizer} />
        }
      </div>
    </AriaColumn>
  );
};
